import { Component, inject } from '@angular/core'

import { MitreInfoComponent } from '../../../../../../../modules/shared/components/mitre-info/mitre-info.component'
import { PackageViewService } from '../../../../../services/reader/package-view.service'

@Component({
  standalone: true,
  selector: 'default-mitre-tab',
  imports: [MitreInfoComponent],
  templateUrl: './mitre-tab.component.html',
  styleUrls: ['./mitre-tab.component.scss'],
})
export class MitreTabComponent {
  private readonly pkgView = inject(PackageViewService)

  readonly pkg = this.pkgView.activePackage
}
